import { render, staticRenderFns } from "./Webhooks.vue?vue&type=template&id=bf206f72&scoped=true&"
import script from "./Webhooks.vue?vue&type=script&lang=js&"
export * from "./Webhooks.vue?vue&type=script&lang=js&"
import style0 from "./Webhooks.vue?vue&type=style&index=0&id=bf206f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf206f72",
  null
  
)

export default component.exports